// extracted by mini-css-extract-plugin
export default {"banner":"ServiceWorkerUpdateNotifier_banner__1BLyO"};